export default __webpack_public_path__ + "static/media/rocket_anim_97.8fd18f36.png";